import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import PortletContent from 'components/PortletContent';
import CircularProgress from '@material-ui/core/CircularProgress';
import Typography from '@material-ui/core/Typography'
import Slider from 'infinite-react-carousel';
import Grid from '@material-ui/core/Grid';
import BounceLoader from 'react-spinners/BounceLoader';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos'
import {getLastAvailabilityStep} from '../../../../../../services/getLastAvailabilityStep'
import compose from 'recompose/compose';
import { withOperativeStateStore } from '../../../../../../store/useOperativeStateConfig';
import { withTranslation } from 'react-i18next';
import { reportFetchError } from '../../../../../../observability/rum';

class AvailabilityStep extends Component {

    constructor(props) {
        super(props);
        this.state = {
            objetivo_id:props.data.id,
            nameObjetive:props.data.name,
            state:props.data.state,
            steps:null,
            isLoading:true,
            user:sessionStorage.getItem("user"),
            token:sessionStorage.getItem("key")
        }
    }
    
    componentDidMount() {
        this.processData();
    }

    // Helper para procesar la data de la petición a la API

    processData = () => {
        const {user, token, state}=this.state
        if(state!=="No monitoreo"){
            getLastAvailabilityStep(this.state.objetivo_id, user, token).then(data => {
                this.setState({
                    steps:data,
                    isLoading:false
                })
            })
            .catch((error) => {
                reportFetchError('LastAvailabilityStep', error)
                this.setState({
                    steps:[],
                    isLoading:false
                })
            })
        }else{
            this.setState({
                steps:[],
                isLoading:false
            })
        }
        
    }

    callBounce(step){
        const rendimiento=<Typography style={{fontWeight:"bold", color:"rgb(102, 120, 138)", fontFamily:"Roboto, Helvetica, Arial, sans-serif"}}>{step.Rendimiento} (s)</Typography>
        if(step.estado==="Uptime"){
            return(<div>
                    <div style={{paddingLeft:"42%"}}><BounceLoader sizeUnit={"px"} size={18} color="#41B900" loading={true}/></div>
                    {rendimiento}
                </div>)
        }else if(step.estado==="Parcial"){
            return(<div>
                <div style={{paddingLeft:"42%"}}><BounceLoader sizeUnit={"px"} size={18} color="#FFC600" loading={true}/></div>
                {rendimiento}
                </div>)
        }else{
            return(<div><div style={{paddingLeft:"42%"}}><BounceLoader sizeUnit={"px"} size={18} color=" #C2272D" loading={true}/></div>
                {rendimiento}
            </div>)
         }
    }

    callName(step){
        var name =step.nombre_paso
        if(name.length>11){
            name=name.substring(0, 11)+"..."
        }

        return(
            <div style={{color:"#66788A", fontFamily: "Roboto, Helvetica, Arial, sans-serif", fontWeight:"bold"}}>
                {name}
            </div>
        )
    }
    
    render() {
        const {  isLoading, state, steps } = this.state;
        const settings={slidesPerRow: 3, nextArrow: <SampleNextArrow />,
            prevArrow: <SamplePrevArrow />,
            autoplay: this.props.store.autoPlaySlider,
            autoplaySpeed: 4000,
        }
        const t = (this.props && this.props.t) ? this.props.t : (s => s)
        if (isLoading===true) {
            return(
                <PortletContent>
                    <Typography
                        variant="h5"
                        align="center"
                    >
                        <CircularProgress
                        variant="indeterminate"

                        size={24}
                        thickness={4}
                        
                    />
                    <br/>
                        {t('text.loading')}
                    </Typography>
                </PortletContent>
            )
        }else if(isLoading===false){
            return(
                <Grid
                    container item
                    direction="row"
                    alignItems="flex-start"
                    style={{height:"120px"}}
                >   
                    <div style={{width:"100%", textAlign:"center", paddingTop:"30px"}}>
                        {state==="No monitoreo" || steps.length===0 ?
                        <Typography style={{color:"#424242"}} variant="h5">{t('text.no-data')}</Typography>
                        :
                        <Slider key={this.props.store.autoPlaySlider.toString()} { ...settings } className='slider-operative-state'>
                            {this.state.steps.map((step, index)=>(
                                <div key={index}>
                                    {this.callName(step)}
                                    {this.callBounce(step)}
                                </div>
                            ))}
                        </Slider>
                        }
                    </div>
                    
                </Grid>
               
            )
        }else return (<p>Error!</p>)
    }
}

function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <ArrowForwardIosIcon
        className={className}
        style={{ ...style, display: "block", color: "grey" }}
        onClick={onClick}
    />
  );
}

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <ArrowBackIosIcon
      className={className}
      style={{ ...style, display: "block", color: "grey" }}
      onClick={onClick}
    />
  );
}



export default compose(withRouter, withOperativeStateStore, withTranslation())(AvailabilityStep);